import { types, Instance } from 'mobx-state-tree';
const { model, string, identifierNumber } = types;

export const ServiceStatusesModel = model('ClientStatusesModel', {
  id: identifierNumber,
  value: string,
  name: string,
  filterName: string,
});

export type IServiceStatusesModel = Instance<typeof ServiceStatusesModel>;
